import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/dialogue")({
  component: Dialogue,
});

function Dialogue() {
  const messages = [
    {
      author: {
        isMainCharacter: true,
        name: "George",
        color: "red",
        align: "left",
      },
      content: "Hallo Peppa",
    },
    {
      author: {
        isMainCharacter: true,
        name: "Peppa",
        color: "blue",
        align: "right",
      },
      content: "Ciao George",
    },
  ];

  return messages.map((message) => {
    return (
      <>
        <div
          className={`text-${message.author.color}-500 text-${message.author.align}`}
        >
          {message.author.name}
        </div>
        <div
          className={`bg-${message.author.color}-500 text-${message.author.align}`}
        >
          {message.content}
        </div>
      </>
    );
  });
}
